import { render, staticRenderFns } from "./PriceReviewDialog.vue?vue&type=template&id=c219dd88&scoped=true&"
import script from "./PriceReviewDialog.vue?vue&type=script&lang=js&"
export * from "./PriceReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./PriceReviewDialog.vue?vue&type=style&index=0&id=c219dd88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c219dd88",
  null
  
)

export default component.exports